import React from 'react';
import BasicButton from '../@common/Buttons/BasicButton';
import circleBackground from 'assets/images/drawn-circle.png';
import { remCalc } from '../../util/style-util';
import { makeStyles } from '@mui/styles';
import { FONT_GSS_FUTURA } from 'themes/default';

type Props = {
  number: number;
} & any;

const useStyles = makeStyles(() => ({
  keypadNumber: {
    backgroundImage: `url(${circleBackground})`,
    backgroundSize: 'cover',
    fontFamily: `${FONT_GSS_FUTURA} !important`,
    fontSize: `${remCalc(36)} !important`,
    margin: remCalc(5, 3),
    minWidth: remCalc(64),
    maxWidth: remCalc(64),
    height: remCalc(64)
  }
}));

const NumberPadButton = ({ number, buttonStyles, ...props }: Props) => {
  const classes = useStyles();

  return (
    <BasicButton buttonStyles={[classes.keypadNumber, buttonStyles]} {...props}>
      {number}
    </BasicButton>
  );
};

export default NumberPadButton;
